// removed by extract-text-webpack-plugin
module.exports = {"background":"_3hPODbfaH4GLmqZvC_TwS9","top":"_3IRHPNr-V-obGFyuAuxKff"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/home/Home.css
// module id = 359
// module chunks = 0